module.exports = __webpack_public_path__ + "static/media/NoDisponiblePromo.b69bb065.svg";